export const s3Config = (type) => ({
  dirName: "sojo/" + type,
  bucketName: "invent-co-new",
  region: "us-east-1",
  accessKeyId: "AKIAFBC97UM4I3ILWTIKQ",
  secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
  bucket_url: "https://s3-noi.aces3.ai/",
});
